import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useWallet, walletErrorMessage } from '~/wallet';
import { AppShell, Button, Card, ErrorText, Spinner } from '~/ui/primitives';

export const Login = observer(() => {
  const { identity } = useWallet();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function handleLogin() {
    setError(null);
    setBusy(true);
    try {
      await identity.login();
      navigate('/account');
    } catch (e) {
      setError(walletErrorMessage(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <AppShell footer="Secured by a passkey on this device — no seed phrase, no extension.">
      <Card>
        <div
          style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-2)', marginBottom: 'var(--space-6)' }}
        >
          <h1 style={{ margin: 0, font: '600 24px/1.25 var(--font-display)', letterSpacing: '-0.01em' }}>
            Sign in to SCP Wallet
          </h1>
          <p style={{ margin: 0, color: 'var(--text-secondary)' }}>Use your passkey to sign in.</p>
        </div>
        <Button onClick={handleLogin} disabled={busy}>
          {busy ? (
            <>
              <Spinner /> Signing in…
            </>
          ) : (
            'Sign in with passkey'
          )}
        </Button>
        {error && (
          <div style={{ marginTop: 'var(--space-4)' }}>
            <ErrorText>{error}</ErrorText>
          </div>
        )}
      </Card>
      <p style={{ margin: 0, textAlign: 'center', color: 'var(--text-secondary)' }}>
        New to SCP Wallet? <Link to="/register">Create new wallet</Link>
      </p>
    </AppShell>
  );
});
